<template>
  <i-modal v-model="inputValue">
    <template #header>
      {{ title }}
    </template>
    <div
      class="_display:flex _justify-content:center"
      am-changed-part-buttons
    >
      <i-button class="_margin-right:1/2" @click="emit('delete')">Delete</i-button>
      <i-button color="primary" @click="emit('cancel')">
        {{ isChanged ? 'Save' : 'Cancel' }}
      </i-button>
    </div>
  </i-modal>
</template>

<script setup>
import { computed, onMounted, onUnmounted, defineEmits, defineProps } from 'vue'
import { useStore } from 'vuex'
const store = useStore()
const emit = defineEmits(['update:modelValue', 'cancel', 'delete'])
const prop = defineProps({
  isShowWarning: {
    type: Boolean,
    default: false
  },
  isDisabled: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: 'Are you sure you want to delete this item?'
  },
  isChanged: {
    type: Boolean,
    default: false
  }
})
const inputValue = computed({
  get () {
    return prop.isShowWarning
  },
  set (val) {
    emit('update:modelValue', val)
  }
})
const close = () => {
  emit('update:modelValue', false)
}
onMounted(() => {
  store.commit('ui/closeModal', close)
})
onUnmounted(() => {
  store.commit('ui/closeModal', null)
})
</script>
